import { interactBest, isNilOrEmpty, IStatusable } from 'helpers';

import { BaseAddr } from './types/BaseAddr';

export function extractBestAddresses<
  TAddressType extends BaseAddr & IStatusable
>(
  addresses: TAddressType[]
) {
  const bestAddress = interactBest(addresses);

  return [bestAddress].filter(n => !isNilOrEmpty(n)) as any[];
}
